import React from 'react'
import {Route, Switch} from 'react-router-dom'
import ListServiceCategories from './ListServiceCategories'
import ShowServiceCategoryPage from './ShowServiceCategoryPage'
import NewServiceCategoryPage from './NewServiceCategoryPage'
import EditServiceCategoryPage from './EditServiceCategoryPage'

const ServiceCategories = ({match}) => (
  <Switch>
    <Route exact path={match.url + '/'} component={ListServiceCategories} />
    <Route exact path={match.url + '/new'} component={NewServiceCategoryPage} />
    <Route path={match.url + '/:id/edit'} component={EditServiceCategoryPage} />
    <Route path={match.url + '/:id'} component={ShowServiceCategoryPage} />
  </Switch>
)

export default ServiceCategories



// WEBPACK FOOTER //
// ./src/components/ServiceCategories/ServiceCategories.jsx